import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { usePurchasingShippingTermsTable } from 'src/pages/settings/admin/purchasingShippingTerms/usePurchasingShippingTermsTable';

export const PurchasingShippingTermsTablePage = () => {
    const [columns, tableSettings] = usePurchasingShippingTermsTable();
    return (
        <>
            <PageHeader {...{
                title: "Purchasing Shipping Terms", subTitle: "View terms for shipping from suppliers",
                components: generateTablePageButtons(tableSettings),
            }} />
            <ContentCardsContainer>
                <ContentCard cardId="Purchasing Shipping Terms" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default PurchasingShippingTermsTablePage;
